import { replaceDynamicPaths } from 'lib/routes/replace-dynamic-paths'

const dashboardRoot = process.env.NEXT_PUBLIC_DASHBOARD_URL

export const dashboardPaths = {
  dashboard: `${dashboardRoot}`,

  login: `${dashboardRoot}/sign-in`,
  register: `${dashboardRoot}/sign-up`,

  new: `${dashboardRoot}/new/[account]`,
  newImport: `${dashboardRoot}/new/[account]`, // TODO: Add support for direct linking in new dashboard
  newTemplate: `${dashboardRoot}/new/[account]`, // TODO: Add support for direct linking in new dashboard
  newOrganization: `${dashboardRoot}/new-organization`,

  settings: `${dashboardRoot}/settings`,
}

const root = '/'

export const websitePaths = {
  root,
  homepage: root,

  emergencyCerkSignin: `${root}clerk/sign-in`,
  githubAuthorize: `${root}callbacks/github/authorize`,
  githubInstalled: `${root}callbacks/github/installed`,

  terms: `${root}terms`,
  privacy: `${root}privacy`,
  fairUse: `${root}fair-use`,

  careers: `${root}careers`,
  career: `${root}careers/[slug]`,

  downloadsCli: `${root}downloads/cli`,
  downloadsGateway: `${root}downloads/gateway`,

  docs: `${root}docs`,
  docsPage: `${root}docs/[...slug]`,

  blog: `${root}blog`,
  blogPage: `${root}blog/[...slug]`,
  blogCategory: `${root}blog/category/[category]`,

  guides: `${root}guides`,
  guidesPage: `${root}guides/[...slug]`,

  changelog: `${root}changelog`,
  changelogPage: `${root}changelog/[...slug]`,

  community: `${root}community`,

  templates: `${root}templates`,

  frameworks: `${root}frameworks`,
  framework: `${root}frameworks/[framework]`,

  examples: `${root}examples`,

  pricing: `${root}pricing`,

  security: `${root}security`,

  roadmap: `${root}roadmap`,

  about: `${root}about`,

  contact: `${root}contact`,
  contactSales: `${root}contact/sales`,

  government: `${root}government`,
  enterprise: `${root}enterprise`,

  // Features pages
  cli: `${root}cli`,
  auth: `${root}auth`,
  edgeGateway: `${root}edge-gateway`,
  branching: `${root}branching`,
  analytics: `${root}analytics`,
  edgeCaching: `${root}edge-caching`,

  // Alternatives
  apolloServer: `${root}alternatives/apollo-server`,
  appSync: `${root}alternatives/appsync`,
  hasura: `${root}alternatives/hasura`,
  graphqlYoga: `${root}alternatives/graphql-yoga`,

  // Use cases
  commerce: `${root}use-cases/commerce`,
  mobile: `${root}use-cases/mobile`,
  web3: `${root}use-cases/web3`,
  bff: `${root}use-cases/backend-for-frontend`,
  ai: `${root}use-cases/ai`,
  logistics: `${root}use-cases/logistics`,
}

export const getWebsiteNewConfigurePath = (
  accountSlug?: string,
  isTemplate?: boolean,
) => {
  const basePath = isTemplate
    ? dashboardPaths.newTemplate
    : dashboardPaths.newImport

  if (accountSlug) {
    return replaceDynamicPaths(basePath, accountSlug)
  }

  return basePath.replace('/[account]', '')
}
